import PeSingleChoice from '../../components/PeSingleChoice';
import PeExtraField from '../../components/PeExtraField';
import PePricingOption from '../../components/PePricingOption';
import PeMoreInfo from '../../components/PeMoreInfo';
import PeNotes from '../../components/PeNotes';

const options = {
  yes_no: [{
    label: 'Yes',
    value: 'yes'
  }, {
    label: 'No',
    value: 'no'
  }]
}

export const productChoiceStepField = [
  {
    name: "add_extras",
    component: PeSingleChoice,
    dependOn: "choice_type_install",
    props: {
      label: "Add Extras",
      required: true,
      options: options.yes_no,
      sm: 2,
      isAuth: true,
    },
  }, {
    name: "formchoice_extra",
    dependOn: "add_extras",
    dependOnValue: "yes",
    component: PeExtraField,
    props: {
      label: "Choice Extras",
      required: true,
    }
  },
  {
    name: "indicative_pricing",
    dependOn: "add_extras",
    component: PeSingleChoice,
    props: {
      label: "Ready for indicative pricing?",
      required: true,
      options: options.yes_no,
      sm: 2,
    },
  },
  {
    name: "indicative_no_moreinfo",
    dependOn: "indicative_pricing",
    dependOnValue: "no",
    component: PeMoreInfo,
    props: {
      button: {
        label: "Get Free Quote",
        link: "#",
      },
      type: "warn",
      label: "Please get in touch by filling our get a free quote page, or alternatively email us info@pure-electric.com.au or give us a call 1300 86 78 73",
    },
  },
  {
    name: "product_choice",
    dependOn: "indicative_pricing",
    dependOnValue: "yes",
    component: PePricingOption,
    props: {
      label: "Product choice",
      required: true,
    },
  }
]